module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('img', {
    staticClass: "head-img round",
    attrs: {
      "src": _vm.userInfo.avatarImgPath || _vm.headImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-name"
  }, [_vm._v(_vm._s(_vm.userInfo.nickName))]), _vm._v(" "), (_vm.userInfo.userRoleList.length > 1) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "setting-item click bd-bot",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'roleList'
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v("切换角色")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.roleName))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.logoutFun
    }
  }, [_vm._v("退出登录")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c49a28","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/index.vue
// module id = qHKs
// module chunks = 51